import user from 'shared_features/lakupandai/store/modules/user';
import mitraItems from './modules/mitraItems';
import walletVji from './modules/walletVji';
import paymentMethodConfig from './modules/paymentMethodConfig';

export default {
  modules: {
    user,
    mitraItems,
    walletVji,
    paymentMethodConfig,
  },
};
